import styled from 'styled-components';
import ColorHelper from '../../helpers/color-helper';
import SercomConstants from '../../support/sercom-constants';

export const CheckboxContainer = styled.div`
  .e-checkbox-wrapper .e-frame.e-check,
  .e-css.e-checkbox-wrapper .e-frame.e-check,
  .e-checkbox-wrapper .e-frame.e-check,
  .e-css.e-checkbox-wrapper .e-frame.e-check,
  .e-checkbox-wrapper .e-checkbox:focus + .e-frame.e-check,
  .e-checkbox-wrapper:hover .e-frame.e-check,
  .e-css.e-checkbox-wrapper:hover .e-frame.e-check .e-css.e-checkbox-wrapper:hover .e-frame.e-check {
    background-color: ${SercomConstants.Color.SURFACE_1};
    border-color: ${SercomConstants.Color.PRIMARY};
    color: ${SercomConstants.Color.PRIMARY};
  }

  .e-checkbox-wrapper .e-frame,
  .e-css.e-checkbox-wrapper .e-frame {
    background-color: ${SercomConstants.Color.SURFACE_1};
    border-color: ${SercomConstants.Color.TYPEFACE_4};
  }

  .e-checkbox-wrapper .e-frame:hover,
  .e-css.e-checkbox-wrapper .e-frame:hover {
    border-color: ${SercomConstants.Color.TYPEFACE_5};
  }

  .e-checkbox-wrapper .e-checkbox:focus + .e-frame.e-check {
    background-color: ${SercomConstants.Color.SURFACE_1};
    border-color: ${SercomConstants.Color.PRIMARY};
    color: ${SercomConstants.Color.PRIMARY};
  }

  .e-checkbox-wrapper.e-checkbox-disabled,
  .e-css.e-checkbox-wrapper.e-checkbox-disabled {
    color: ${ColorHelper.applyOpacity(SercomConstants.Color.TYPEFACE_4, 0.2)};
    border-color: ${ColorHelper.applyOpacity(SercomConstants.Color.TYPEFACE_4, 0.2)};
  }

  .e-checkbox-wrapper .e-checkbox:active + .e-frame.e-check {
    background-color: ${SercomConstants.Color.SURFACE_1};
    border-color: ${SercomConstants.Color.PRIMARY};
    color: ${SercomConstants.Color.PRIMARY};
  }
`;
